import { render } from "./PrintOgData.vue?vue&type=template&id=cc049486&scoped=true&ts=true"
import script from "./PrintOgData.vue?vue&type=script&lang=ts"
export * from "./PrintOgData.vue?vue&type=script&lang=ts"

import "./PrintOgData.vue?vue&type=style&index=0&id=cc049486&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc049486"]])

export default __exports__